import axios from 'axios';

// API base URL — build sırasında REACT_APP_API_URL ile geçilebilir.
// Geliştirmede tanımlı değilse localhost'a düşer.
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const API = axios.create({
  baseURL: API_BASE_URL
});

const TOKEN_KEY = 'evdeye_token';

// Request interceptor: her isteğe token ekle (varsa)
API.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor: 401 → eğer token VARSA (süresi doldu/geçersiz)
// temizleyip login ekranına yönlendir. Token yoksa 401 beklenen sonuç,
// karşılama ekranındaki sessiz çağrılarda sonsuz reload'a sebep olmasın.
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const hadToken = !!localStorage.getItem(TOKEN_KEY);
      if (hadToken) {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem('evdeye_user');
        if (window.location.pathname !== '/') {
          window.location.href = '/';
        } else {
          window.location.reload();
        }
      }
    }
    return Promise.reject(err);
  }
);

export const stokHareketleriAPI = {
  malzeme: (params) => API.get('/stok-hareketleri/malzeme', { params }),
  urun: (params) => API.get('/stok-hareketleri/urun', { params }),
};

export const malzemelerAPI = {
  getAll: () => API.get('/malzemeler'),
  getById: (id) => API.get(`/malzemeler/${id}`),
  getKullanim: (id) => API.get(`/malzemeler/${id}/kullanim`),
  getDetay: (id) => API.get(`/malzemeler/${id}/detay`),
  create: (data) => API.post('/malzemeler', data),
  update: (id, data) => API.put(`/malzemeler/${id}`, data),
  remove: (id) => API.delete(`/malzemeler/${id}`)
};

export const urunlerAPI = {
  getAll: () => API.get('/urunler'),
  getById: (id) => API.get(`/urunler/${id}`),
  getDetay: (id) => API.get(`/urunler/${id}/detay`),
  create: (data) => API.post('/urunler', data),
  update: (id, data) => API.put(`/urunler/${id}`, data),
  remove: (id) => API.delete(`/urunler/${id}`)
};

export const urunRecetelerAPI = {
  getAll: () => API.get('/urun-receteleri'),
  getByUrun: (urunId) => API.get(`/urun-receteleri/urun/${urunId}`),
  getById: (id) => API.get(`/urun-receteleri/${id}`),
  create: (data) => API.post('/urun-receteleri', data),
  update: (id, data) => API.put(`/urun-receteleri/${id}`, data),
  aktiveEt: (id) => API.put(`/urun-receteleri/${id}/aktive-et`),
  remove: (id) => API.delete(`/urun-receteleri/${id}`)
};

export const malzemeBirimDonusumleriAPI = {
  getAllSon: () => API.get('/malzeme-birim-donusumleri/son'),
  getByMalzeme: (malzemeId) => API.get(`/malzeme-birim-donusumleri/${malzemeId}`),
  create: (data) => API.post('/malzeme-birim-donusumleri', data),
};

export const uretimlerAPI = {
  getAll: () => API.get('/uretimler'),
  create: (data) => API.post('/uretimler', data),
  update: (id, data) => API.put(`/uretimler/${id}`, data),
  onayla: (id) => API.put(`/uretimler/${id}/onayla`),
  topluOnayla: (ids) => API.put('/uretimler/toplu-onayla', { ids }),
  malzemeIhtiyac: (kalemler) => API.post('/uretimler/malzeme-ihtiyac', { kalemler }),
  malzemeIhtiyacDetayli: (kalemler) => API.post('/uretimler/malzeme-ihtiyac-detayli', { kalemler }),
  remove: (id) => API.delete(`/uretimler/${id}`)
};

export const satislarAPI = {
  getAll: () => API.get('/satislar'),
  getById: (id) => API.get(`/satislar/${id}`),
  create: (data) => API.post('/satislar', data),
  update: (id, data) => API.put(`/satislar/${id}`, data),
  remove: (id) => API.delete(`/satislar/${id}`),
};

export const alislarAPI = {
  getAll: () => API.get('/alislar'),
  getById: (id) => API.get(`/alislar/${id}`),
  create: (data) => API.post('/alislar', data),
  update: (id, data) => API.put(`/alislar/${id}`, data),
  remove: (id) => API.delete(`/alislar/${id}`)
};

export const carilerAPI = {
  getAll: () => API.get('/cariler'),
  getById: (id) => API.get(`/cariler/${id}`),
  create: (data) => API.post('/cariler', data),
  update: (id, data) => API.put(`/cariler/${id}`, data),
  remove: (id) => API.delete(`/cariler/${id}`)
};

export const islemlerAPI = {
  getAll: (params) => API.get('/islemler', { params }),
  getById: (id) => API.get(`/islemler/${id}`),
  create: (data) => API.post('/islemler', data),
  update: (id, data) => API.put(`/islemler/${id}`, data),
  remove: (id) => API.delete(`/islemler/${id}`),
  getVirmanlar: () => API.get('/islemler/virmanlar'),
  createVirman: (data) => API.post('/islemler/virman', data),
  updateVirman: (id, data) => API.put(`/islemler/virman/${id}`, data),
  removeVirman: (id) => API.delete(`/islemler/virman/${id}`)
};

export const kullanicilarAPI = {
  getAll: () => API.get('/kullanicilar'),
  getById: (id) => API.get(`/kullanicilar/${id}`),
  create: (data) => API.post('/kullanicilar', data),
  update: (id, data) => API.put(`/kullanicilar/${id}`, data),
  remove: (id) => API.delete(`/kullanicilar/${id}`),
  login: (data) => API.post('/kullanicilar/login', data)
};

export const satisTakvimiAPI = {
  getAll: () => API.get('/satis-takvimi'),
  getByMonth: (yil, ay) => API.get('/satis-takvimi/aylik', { params: { yil, ay } }),
  getByDate: (tarih) => API.get(`/satis-takvimi/gun/${tarih}`),
  create: (data) => API.post('/satis-takvimi', data),
  bulkCreate: (kayitlar) => API.post('/satis-takvimi/toplu', { kayitlar }),
  update: (id, data) => API.put(`/satis-takvimi/${id}`, data),
  remove: (id) => API.delete(`/satis-takvimi/${id}`),
  removeByDate: (tarih) => API.delete(`/satis-takvimi/gun/${tarih}`),
  menuleriYukle: (data) => API.post('/satis-takvimi/menuler-toplu-yukle', data),
  getSabitUrunler: () => API.get('/satis-takvimi/sabit-urunler'),
  addSabitUrun: (urun_id) => API.post('/satis-takvimi/sabit-urunler', { urun_id }),
  removeSabitUrun: (id) => API.delete(`/satis-takvimi/sabit-urunler/${id}`)
};

export const gununMenuleriAPI = {
  getByMonth: (yil, ay) => API.get('/gunun-menuleri', { params: { yil, ay } }),
  getByDate: (tarih) => API.get(`/gunun-menuleri/tarih/${tarih}`),
  upsert: (data) => API.post('/gunun-menuleri', data),
  remove: (id) => API.delete(`/gunun-menuleri/${id}`),
};

export const gunUretimPlaniAPI = {
  getByDate: (tarih) => API.get(`/gun-uretim-plani/tarih/${tarih}`),
  upsert: (data) => API.post('/gun-uretim-plani', data),
};

export const eslesmelerAPI = {
  getAll: (params = {}) => API.get('/eslesmeler', { params }),
};

export const satisVadeleriAPI = {
  getBySatis: (satisId) => API.get(`/satis-vadeleri/satis/${satisId}`),
  getAcikByCari: (cariId) => API.get(`/satis-vadeleri/cari/${cariId}/acik`),
};

export const alisVadeleriAPI = {
  getByAlis: (alisId) => API.get(`/alis-vadeleri/alis/${alisId}`),
  getAcikByCari: (cariId) => API.get(`/alis-vadeleri/cari/${cariId}/acik`),
};

export const cariBakiyeAPI = {
  getOzet: (cariId) => API.get(`/cari-bakiye/cari/${cariId}/ozet`),
  getVadesiGecenler: () => API.get('/cari-bakiye/vadesi-gecenler'),
  getYaslandirma: (cariId) => API.get('/cari-bakiye/yaslandirma', { params: cariId ? { cari_id: cariId } : {} }),
};

export const musteriAnlasmaFiyatiTarihceAPI = {
  getByMusteri: (musteriId) => API.get(`/musteri-anlasma-fiyati-tarihce/musteri/${musteriId}`),
  getActiveByDate: (musteriId, tarih) => API.get(`/musteri-anlasma-fiyati-tarihce/musteri/${musteriId}/tarih/${tarih}`),
  create: (data) => API.post('/musteri-anlasma-fiyati-tarihce', data),
  update: (id, data) => API.put(`/musteri-anlasma-fiyati-tarihce/${id}`, data),
  remove: (id) => API.delete(`/musteri-anlasma-fiyati-tarihce/${id}`),
};

export const takvimEkstraMenuleriAPI = {
  getByMonth: (yil, ay) => API.get('/takvim-ekstra-menuleri', { params: { yil, ay } }),
  getByDate: (tarih) => API.get(`/takvim-ekstra-menuleri/tarih/${tarih}`),
  create: (data) => API.post('/takvim-ekstra-menuleri', data),
  update: (id, data) => API.put(`/takvim-ekstra-menuleri/${id}`, data),
  remove: (id) => API.delete(`/takvim-ekstra-menuleri/${id}`),
};

export const listeFiyatlariAPI = {
  getAll: () => API.get('/liste-fiyatlari'),
  getById: (id) => API.get(`/liste-fiyatlari/${id}`),
  getByTip: (tur, tipId) => API.get(`/liste-fiyatlari/tip/${tur}/${tipId}`),
  getLog: (id) => API.get(`/liste-fiyatlari/${id}/log`),
  create: (data) => API.post('/liste-fiyatlari', data),
  update: (id, data) => API.put(`/liste-fiyatlari/${id}`, data),
  remove: (id) => API.delete(`/liste-fiyatlari/${id}`)
};

export const musterilerAPI = {
  getAll: () => API.get('/musteriler'),
  getById: (id) => API.get(`/musteriler/${id}`),
  update: (id, data) => API.put(`/musteriler/${id}`, data)
};

export const kasalarAPI = {
  getAll: () => API.get('/kasalar'),
  getById: (id) => API.get(`/kasalar/${id}`),
  create: (data) => API.post('/kasalar', data),
  update: (id, data) => API.put(`/kasalar/${id}`, data),
  remove: (id) => API.delete(`/kasalar/${id}`)
};

export const yetkilerAPI = {
  getAll: () => API.get('/yetkiler'),
  getByRol: (rol) => API.get(`/yetkiler/${rol}`),
  update: (rol, izinler) => API.put(`/yetkiler/${rol}`, { izinler }),
};

export const gelirTipleriAPI = {
  getAll: () => API.get('/gelir-tipleri'),
  getById: (id) => API.get(`/gelir-tipleri/${id}`),
  create: (data) => API.post('/gelir-tipleri', data),
  update: (id, data) => API.put(`/gelir-tipleri/${id}`, data),
  remove: (id) => API.delete(`/gelir-tipleri/${id}`)
};

export const giderTipleriAPI = {
  getAll: () => API.get('/gider-tipleri'),
  getById: (id) => API.get(`/gider-tipleri/${id}`),
  create: (data) => API.post('/gider-tipleri', data),
  update: (id, data) => API.put(`/gider-tipleri/${id}`, data),
  remove: (id) => API.delete(`/gider-tipleri/${id}`)
};


export const faturaOkumaAPI = {
  oku: (dosya) => {
    const formData = new FormData();
    formData.append('dosya', dosya);
    return API.post('/fatura-oku', formData, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 60000 });
  }
};

export const odemeRutinleriAPI = {
  getAll: () => API.get('/odeme-rutinleri'),
  create: (data) => API.post('/odeme-rutinleri', data),
  update: (id, data) => API.put(`/odeme-rutinleri/${id}`, data),
  remove: (id) => API.delete(`/odeme-rutinleri/${id}`)
};

const crudAPI = (path) => ({
  getAll: () => API.get(path),
  getById: (id) => API.get(`${path}/${id}`),
  create: (data) => API.post(path, data),
  update: (id, data) => API.put(`${path}/${id}`, data),
  remove: (id) => API.delete(`${path}/${id}`)
});

export const birimlerAPI = crudAPI('/birimler');
export const urunTipleriAPI = crudAPI('/urun-tipleri');
export const malzemeTipleriAPI = crudAPI('/malzeme-tipleri');
export const cariTipleriAPI = crudAPI('/cari-tipleri');
export const kdvOranlariAPI = crudAPI('/kdv-oranlari');
export const paketlemeTipleriAPI = crudAPI('/paketleme-tipleri');
export const faturaDurumlariAPI = crudAPI('/fatura-durumlari');

export const raporlamaAPI = {
  gunlukKarZarar: (tarih) => API.get('/raporlama/kar-zarar/gunluk', { params: { tarih } }),
  aylikKarZarar: (yil, ay) => API.get('/raporlama/kar-zarar/aylik', { params: { yil, ay } }),
  stokDurum: () => API.get('/raporlama/stok-durum'),
  gelirGiderAylik: (baslangic, bitis) => API.get('/raporlama/gelir-gider/aylik', { params: { baslangic, bitis } }),
  gelirGiderDetay: (params) => API.get('/raporlama/gelir-gider/detay', { params }),
  inceleme: (params) => API.get('/raporlama/inceleme', { params })
};
